import type { FC, ReactNode } from 'react';
import { useState } from 'react';
import { Button } from 'antd';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import { FormDrawer } from 'components/common/form-drawer';
import type { IFormDrawerWithButtonProps } from 'components/common/form-drawer-with-button/types';
import { EFormDrawerWithButtonIconType } from 'components/common/form-drawer-with-button/types';

export const FormDrawerWithButton = <T extends FC<any> = FC<any>>(props: IFormDrawerWithButtonProps<T>) => {
  const {
    buttonLabel,
    iconType = EFormDrawerWithButtonIconType.CREATE,
    buttonType = 'primary',
    buttonDisabled = false,
    onClose,
    ...formDrawerProps
  } = props;

  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => {
    setIsOpen(false);
    onClose?.();
  };

  const renderIcon = (): ReactNode => {
    switch (iconType) {
      case EFormDrawerWithButtonIconType.CREATE:
        return <PlusOutlined />;
      case EFormDrawerWithButtonIconType.EDIT:
        return <EditOutlined />;
      default:
        return null;
    }
  };

  return (
    <>
      <Button type={buttonType} icon={renderIcon()} disabled={buttonDisabled} onClick={handleOpen}>
        {buttonLabel}
      </Button>
      <FormDrawer isOpen={isOpen} onClose={handleClose} {...formDrawerProps} />
    </>
  );
};
